import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/**
 * `eventName` matches the `type` of the actions dispatched by `Application/WorkflowRuns/**`.
 * A failed read is never toasted: the screen it feeds renders its own error state, and the refetch that
 * follows a removal or a retry swallows its own failure (`WORKFLOW_RUN_FETCH_FAILED` is deliberately absent).
 */
const PreparationsNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="WORKFLOW_RUN_OPENED"
				title="Préparation ouverte"
				message="La préparation a bien été ouverte."
			/>
			<ErrorNotification
				eventName="WORKFLOW_RUN_OPENING_FAILED"
				title="Erreur"
				message="La préparation n'a pas pu être ouverte."
			/>
			<SuccessNotification
				eventName="WORKFLOW_RUN_SOURCE_ADDED"
				title="Élément ajouté"
				message="L'élément a bien été ajouté à la préparation."
			/>
			<SuccessNotification
				eventName="WORKFLOW_RUN_SOURCE_REMOVED"
				title="Élément retiré"
				message="L'élément a bien été retiré de la préparation."
			/>
			<SuccessNotification
				eventName="WORKFLOW_RUN_GENERATION_LAUNCHED"
				title="Génération lancée"
				message="La génération des documents a démarré."
			/>
			<SuccessNotification
				eventName="WORKFLOW_RUN_SOURCE_TRANSCRIPTION_LAUNCHED"
				title="Transcription lancée"
				message="La transcription de l'enregistrement a démarré."
			/>
			<SuccessNotification
				eventName="WORKFLOW_RUN_ABANDONED"
				title="Préparation abandonnée"
				message="La préparation a été abandonnée. Rien n'a été perdu : les entretiens, notes et documents restent au dossier."
			/>
			<SuccessNotification
				eventName="WORKFLOW_RUN_HANDLED"
				title="Préparation traitée"
				message="Préparation marquée comme traitée."
			/>
			<ErrorNotification
				eventName="WORKFLOW_RUN_HANDLING_FAILED"
				title="Erreur"
				message="La préparation n'a pas pu être marquée comme traitée."
			/>
			<ErrorNotification
				eventName="WORKFLOW_RUN_SOURCE_ADDITION_FAILED"
				title="Erreur"
				message="L'élément n'a pas pu être ajouté à la préparation."
			/>
			<ErrorNotification
				eventName="WORKFLOW_RUN_SOURCE_REMOVAL_FAILED"
				title="Erreur"
				message="L'élément n'a pas pu être retiré de la préparation."
			/>
			<ErrorNotification
				eventName="WORKFLOW_RUN_GENERATION_LAUNCH_FAILED"
				title="Génération refusée"
				message="La génération n'a pas pu être lancée."
			/>
			<ErrorNotification
				eventName="WORKFLOW_RUN_ABANDONMENT_FAILED"
				title="Erreur"
				message="La préparation n'a pas pu être abandonnée."
			/>
			<ErrorNotification
				eventName="WORKFLOW_RUN_SOURCE_TRANSCRIPTION_LAUNCH_FAILED"
				title="Transcription refusée"
				message="La transcription n'a pas pu être lancée."
			/>
			<ErrorNotification
				eventName="FACILITY_WORKFLOWS_FETCH_FAILED"
				title="Erreur"
				message="Les groupes de documents n'ont pas pu être chargés."
			/>
			<ErrorNotification
				eventName="BENEFICIARY_WORKFLOW_RUNS_FETCH_FAILED"
				title="Erreur"
				message="Les préparations n'ont pas pu être chargées."
			/>
		</React.Fragment>
	);
};

export default PreparationsNotifications;
